package com.anjuros.website.templates.template9.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template9.components.Template9HeartIcon
import com.anjuros.website.templates.template9.components.Template9Header
import com.anjuros.website.templates.template9.components.Template9OutlineButton
import com.anjuros.website.templates.template9.components.Template9PrimaryButton
import com.anjuros.website.templates.template9.components.Template9Sparks
import com.anjuros.website.templates.template9.components.Template9Trail
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.modules.getColorHex
import com.anjuros.website.templates.template9.styles.TEMPLATE9_BLOB_HERO
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9HeroImageStyle
import com.anjuros.website.templates.template9.styles.Template9HeroSubtitleStyle
import com.anjuros.website.templates.template9.styles.Template9HeroTitleStyle
import com.anjuros.website.templates.template9.styles.template9Blob
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template9MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuClicked: () -> Unit = {}
) {
    Column(
        modifier = modifier
            .id(Template9Section.Home.id)
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb)
            .overflow(Overflow.Hidden),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template9Header { onMenuClicked() }
        Template9Hero()
    }
}

@Composable
private fun Template9Hero() {

    var visible by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        delay(150)
        visible = true
    }

    Box(
        modifier = Template9ContainerStyle.toModifier()
            .padding(top = 30.px, bottom = 70.px)
    ) {
        Template9Trail(
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.BottomStart)
                .margin(left = (-70).px, bottom = (-40).px)
                .opacity(0.6f),
            color = Template9Theme.Primary.getColorHex()
        )

        SimpleGrid(
            numColumns = numColumns(base = 1, lg = 2),
            modifier = Modifier.fillMaxWidth()
        ) {
            Column(
                modifier = Modifier
                    .opacity(if (visible) 1f else 0f)
                    .translateY(if (visible) 0.px else 30.px)
                    .styleModifier {
                        property("align-self", "center")
                        property("transition", "opacity 900ms ease, translate 900ms ease")
                    }
            ) {
                Template9HeroText()
            }

            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                Template9HeroImage()
            }
        }
    }
}

@Composable
private fun Template9HeroText() {

    Template9Sparks(
        modifier = Modifier.margin(left = (-14).px, bottom = (-6).px),
        color = Template9Theme.Accent.hex
    )

    Row(
        verticalAlignment = Alignment.Bottom,
        modifier = Modifier.gap(12.px)
    ) {
        P(
            attrs = Template9HeroTitleStyle.toModifier()
                .margin(0.px)
                .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
                .fontWeight(FontWeight.Bold)
                .color(Template9Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE9_HERO_TITLE))
        }
        Template9HeartIcon(
            modifier = Modifier.margin(bottom = 14.px),
            size = 34,
            color = Template9Theme.Accent.hex
        )
    }

    P(
        attrs = Template9HeroSubtitleStyle.toModifier()
            .margin(top = 26.px, bottom = 18.px)
            .fontFamily(Template9Constants.FONT_FAMILY)
            .fontWeight(FontWeight.Bold)
            .color(Template9Theme.Secondary.rgb)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE9_HERO_SUBTITLE) + " ")
        Span(
            attrs = Modifier
                .color(Template9Theme.Primary.getColor())
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE9_HERO_TITLE2))
        }
    }

    P(
        attrs = Modifier
            .maxWidth(420.px)
            .margin(top = 0.px, bottom = 34.px)
            .fontFamily(Template9Constants.FONT_FAMILY)
            .fontSize(16.px)
            .lineHeight(1.7)
            .color(Template9Theme.Text.rgb)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE9_HERO_DESCRIPTION))
    }

    Row(
        modifier = Modifier.gap(16.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Template9PrimaryButton(
            text = ResKey.TEMPLATE9_BUTTON_BOOK,
            path = Template9Section.Contact.path
        )
        Template9OutlineButton(
            text = ResKey.TEMPLATE9_BUTTON_LEARN,
            path = Template9Section.AboutMe.path
        )
    }
}

@Composable
private fun Template9HeroImage() {
    Box(
        modifier = Template9HeroImageStyle.toModifier()
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .template9Blob(TEMPLATE9_BLOB_HERO)
                .overflow(Overflow.Hidden)
                .border(width = 6.px, style = LineStyle.Solid, color = Colors.White)
                .boxShadow(offsetY = 18.px, blurRadius = 40.px, color = rgba(27, 33, 66, 0.15))
        ) {
            AnjurosImage(
                modifier = Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover),
                src = Template9Res.Image.hero,
                alt = "Happy dog on a walk with a professional dog walker"
            )
        }
        Template9Sparks(
            modifier = Modifier
                .align(Alignment.TopStart)
                .margin(left = (-20).px, top = 10.px),
            size = 46,
            color = Template9Theme.Primary.getColorHex()
        )
        Template9Sparks(
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .margin(right = (-18).px, bottom = 24.px),
            size = 46,
            color = Template9Theme.Primary.getColorHex()
        )
    }
}
